/** `?thread=<id>` on any page opens the Team dock on that conversation (a deep link; the dock then removes it). */
export const THREAD_PARAM = 'thread';

/** The retired Messages page's address: with the switch on, the shell sends it to the Dashboard (keeping `?thread=`). */
const MESSAGES_PATH = '/messages';

/** Whether an address is the retired Messages page. */
export function isMessagesPath(pathname: string): boolean {
  return pathname === MESSAGES_PATH || pathname.startsWith(`${MESSAGES_PATH}/`);
}
